// src/pages/CustomerSpecialPrice/index.js
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { App, Button, Card, Typography } from "antd";
import { ArrowLeftOutlined, PlusOutlined } from "@ant-design/icons";
import CreateCustomerSpecialPriceForm from "./components/CreateCustomerSpecialPriceForm";
import CustomerSpecialPriceTable from "./components/CustomerSpecialPriceTable";
import { fetchCustomerSpecialPriceList } from "./CustomerSpecialPriceThunk";
import { resetForm } from "./CustomerSpecialPriceSlice";
import { useNavigate } from "react-router-dom";

const CustomerSpecialPrice = () => {
  const { message } = App.useApp();
  const dispatch = useDispatch();
  const { list, loading, accessType, showForm, isEdit } = useSelector(
    (state) => state.customerSpecialPrice
  );

  const navigate = useNavigate();
  const { Title } = Typography;

  const [formVisible, setFormVisible] = useState(false);

  useEffect(() => {
    dispatch(fetchCustomerSpecialPriceList());
  }, [dispatch]);

  useEffect(() => {
    if (isEdit) {
      setFormVisible(true);
    }
  }, [isEdit]);

  const handleNavigateToBack = () => {
    dispatch(resetForm());
    if (formVisible) return setFormVisible(false);
    navigate("/sales-dashboard");
  };
  const handleCancel = () => {
    dispatch(resetForm());
    setFormVisible(false);
  };

  const handleAddNew = () => {
    dispatch(resetForm());
    setFormVisible(true);
  };

  return (
    <div className="p-4">
      <App>
        {/* <Card>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "24px",
            }}
          >
            <Button
              type="text"
              icon={<ArrowLeftOutlined style={{ fontSize: "22px" }} />} // ✅ Scaled to match Title
              onClick={handleNavigateToBack}
              style={{
                marginRight: 12,
                padding: 0,
                height: "auto",
                lineHeight: "1",
                color: "#000", // optional, keeps consistent with text color
              }}
            />
            <Title level={3} style={{ margin: 0 }}>
              Contract Sales
            </Title>
          </div>
        </Card> */}
        {formVisible ? (
          <CreateCustomerSpecialPriceForm
            onCancel={handleCancel}
            messageApi={message}
          />
        ) : (
          <>
            {accessType === "WRITE" && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  marginBlock: "24px",
                }}
              >
                <Button
                  type="primary"
                  icon={<PlusOutlined />}
                  onClick={handleAddNew}
                >
                  Add New
                </Button>
              </div>
            )}
            <CustomerSpecialPriceTable
              data={list}
              loading={loading}
              messageApi={message}
            />
          </>
        )}
      </App>
    </div>
  );
};

export default CustomerSpecialPrice;
